import React from "react";
import { Paper } from "@mui/material";

function ChatbotInitialPrompt({ initialMessage }) {
  const [value, setValue] = React.useState("");
  const paperCss = {
    p: 1,
    maxWidth: "80%",
    textAlign: "left",
    backgroundColor: "#f0f4f8",
    borderRadius: "8px",
    fontSize: "12px",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        paddingLeft: "16px",
        paddingRight: "16px",
        fontSize: "12px",
      }}
    >
      <Paper sx={paperCss}>{initialMessage.first}</Paper>
      <Paper sx={paperCss}>{initialMessage.second}</Paper>
      <Paper sx={paperCss}>
        {initialMessage.third}
        <ul className="list-disc list-inside">
          {initialMessage.list &&
            initialMessage.list.map((message, index) => (
              <li key={index}>{message}</li>
            ))}
        </ul>
      </Paper>
      <Paper sx={paperCss}>{initialMessage.last}</Paper>
    </div>
  );
}

export default ChatbotInitialPrompt;
